module.exports = __webpack_public_path__ + "img/index-solutions-net.b1a70fed.png";